import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleApiError } from "../../../Common/errorApiHandleUtils";
import { checkFilter } from "../../../Common/filterUtils";
import { branchService } from "../../../Axios/branchService";

export const getBranch = createAsyncThunk(
    'branch/getBranch',
    async (filters, { rejectWithValue }) => {
        try {
            let filter = checkFilter(filters);
            const response = await branchService.getBranch(filter);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const submitBranch = createAsyncThunk(
    'branch/submitBranch',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append('name', data.name);
            formData.append('location', data.location);
            formData.append('phone', data.phone);
            data.operation_hours && formData.append('operation_hours', JSON.stringify(data.operation_hours));
            formData.append('latitude', data.latitude);
            formData.append('longitude', data.longitude);
            data.photos && formData.append('photos', data.photos);
            if (data.banner && data.banner.length > 0) {
                console.log(data.banner, 'data.banner lebih dari 0');
                data.banner.forEach((banner, index) => {
                    formData.append(`banner[${index}]`, banner);
                });
            } else {
                formData.append('banner', []);
            }
            
            let response;
            if (data.id) {
                response = await branchService.updateBranch(data.id, formData);
            } else {
                response = await branchService.createBranch(formData);
            }
            data.successCallback && data.successCallback();
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteBranch = createAsyncThunk(
    'branch/deleteBranch',
    async (id, { rejectWithValue }) => {
        try {
            const response = await branchService.deleteBranch(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const deleteBanner = createAsyncThunk(
    'branch/deleteBanner',
    async ({ id, pivotId }, { rejectWithValue }) => {
        try {
            const response = await branchService.deleteBanner(id, pivotId);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const attachTreatment = createAsyncThunk(
    'branch/attachTreatment',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            data.treatment_id && data.treatment_id.length > 0 && data.treatment_id.forEach((treatmentId) => {
                formData.append('treatment_id[]', treatmentId);
            });
            const response = await branchService.attachTreatment(data.branch_id, formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const attachDoctor = createAsyncThunk(
    'branch/attachDoctor',
    async (data, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            data.doctor_id && data.doctor_id.length > 0 && data.doctor_id.forEach((doctorId) => {
                formData.append('doctor_id[]', doctorId);
            });
            const response = await branchService.attachDoctor(data.branch_id, formData);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const getSetupSchedule = createAsyncThunk(
    'branch/getSetupSchedule',
    async (id, { rejectWithValue }) => {
        try {
            const response = await branchService.getSetupSchedule(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);

export const getBranchSchedule = createAsyncThunk(
    'branch/getBranchSchedule',
    async (id, { rejectWithValue }) => {
        try {
            const response = await branchService.getBranchSchedule(id);
            return response.data;
        } catch (error) {
            return rejectWithValue(handleApiError(error));
        }
    }
);
